import ES6Promise from "es6-promise";
import { request } from 'newcar-ui/output/es/utils/request';
if (!window.Promise) {
  ES6Promise.polyfill();
}
if (typeof window != "undefined") {
  // 由于window.onload 一个页面只能执行一次，addEventListener可以执行多次
  window.addEventListener('load', () => {
    // 必须加个延时，否则在native嵌入H5的时候第二次进入页面之后load时机会发生错误，在页面没有加载之前就会执行
    setTimeout(() => {
      let aTags = document.getElementsByTagName('a');
      for (let i = 0; i < aTags.length; i++) {
        let aTag = aTags[i];
        // 新版曝光 属性 data-exposeurl
        let exposeUrl = aTag.getAttribute('data-exposeurl');
        // 判断新版曝光链接是否存在
        if (exposeUrl) {
          request(exposeUrl, '')
            .then(() => {
              // 
            })
            .catch(() => {
              // 
            });
        }
      }
    }, 600)

  })
}
